export const AGGREGATED_REACTIONS_BAR_SEGMENT_TEST_ID = "aggregated-reactions-bar-segment";
